// extracted by mini-css-extract-plugin
export default {"box":"InfoBox2_box__WmjDr","title":"InfoBox2_title__H4nro","subtitle":"InfoBox2_subtitle__AXFt-"};